module.exports = __webpack_public_path__ + "static/media/item_14_4_comp.5e41f7a9.png";